import { injectAuthContainer } from 'utils/routing'

const Routing = injectAuthContainer(require('./routing').default)

export { Routing }
